// format.ts — интерполяция {name} в строке словаря: только подстановка значения,
// без выражений и без HTML (значения идут в текстовые узлы React, экранирования не требуют).
export function interpolate(template, args) {
    if (!args)
        return template;
    return template.replace(/\{(\w+)\}/g, (match, key) => {
        if (!(key in args)) {
            if (process.env.NODE_ENV !== "production") {
                // eslint-disable-next-line no-console
                console.warn(`i18n: аргумент "${key}" не передан для плейсхолдера в "${template}"`);
            }
            return match;
        }
        return String(args[key]);
    });
}
